import Route from '@ember/routing/route';

export default class ReportingUpdatesRoute extends Route {}
